export { FeatureElectricCars } from './lib/landing-feature-electric-cars'
export { getStaticProps } from './lib/get-static-props'
export type { ElectricCarsProps } from './lib/get-static-props'
export type { ElectricCarsPageStoryContent } from './lib/types/electric-cars-page'
